<template>
  <div class="container extend-page">
    <!-- 头部导航 -->
    <header-bar name="待处理投诉" />
    <!-- 无数据 -->
    <empty text="目前暂无待处理投诉" v-if="arrService.length == 0" />
    <div class="list" v-if="arrService.length > 0">
      <div class="item" v-for="(item, index) in arrService" :key="index">
        <div class="base">
          <div class="code">{{ item.sn }}</div>
          <div class="type">{{ type[item.type] }}</div>
        </div>
        <div class="info">
          <div class="row">
            <div class="lab">下单人</div>
            <div class="inf">
              {{ item.sendUserName }} - {{ item.sendUserPhone }}
            </div>
          </div>
          <div class="row">
            <div class="lab">下单时间</div>
            <div class="inf">{{ item.sendUserCreateTime }}</div>
          </div>
          <div class="row">
            <div class="lab">接单人</div>
            <div class="inf">
              {{ item.receivingUserName }} - {{ item.receivingUserPhone }}
            </div>
          </div>
          <div class="row">
            <div class="lab">接单时间</div>
            <div class="inf">{{ item.receivingUserCreateTime }}</div>
          </div>
        </div>
        <div class="link">
          <div class="lnk-item lnk-ok" :data-code="item.id" @click="handlerDo">
            处理投诉
          </div>
          <!--					<div class="lnk-item lnk-default"-->
          <!--					:data-code='item.code'-->
          <!--					@click="handlerClose"-->
          <!--					>关闭投诉</div>-->
        </div>
      </div>
    </div>
    <!-- 触底 -->
    <loading-more
      v-show="isLoading && !isHadMore && arrService.length > 0"
      @doLoading="list"
      :isNoData="isHadMore"
      :isLoading="isLoading"
    />
  </div>
</template>

<script>
import HeaderBar from "components/HeaderBar/HeaderBar";
import Empty from "components/Empty/Empty";
import LoadingMore from "@/components/LoadingMore/LoadingMore";
import { complaintList } from "@/api/home";
import { passportUserInfo } from "@/api/login";
export default {
  name: "ServiceList",
  components: {
    HeaderBar,
    LoadingMore,
    Empty,
  },
  data() {
    return {
      arrService: [],
      isLoading: false,
      isHadMore: true,
      pages: 999,
      type: { 1: "订单投诉", 2: "聊天投诉" },
    };
  },
  methods: {
    // 关闭投诉
    handlerClose: function (e) {
      let eCode = e.currentTarget.dataset.code;
      this.$dialog
        .confirm({
          title: "系统提示",
          message: "您确定要关闭当前投诉吗？",
        })
        .then(() => {
          console.log("调用关闭投诉接口", eCode);
        })
        .catch(() => {
          console.log("不关闭投诉", eCode);
        });
    },

    // 处理投诉
    handlerDo: function (e) {
      let eCode = e.currentTarget.dataset.code;
      this.$router.push({
        path: "/service-detail",
        query: {
          code: eCode,
        },
      });
    },
    list: function () {
      this.isLoading = true;

      if (this.pages + 1 == this.pageNumber && this.arrEmployee.length > 0) {
        this.isHadMore = false;
      }

      if (this.pages + 1 == this.pageNumber) {
        return;
      }
      complaintList({
        pageNumber: this.pageNumber,
        pageSize: 10,
        type: 1,
      }).then((res) => {
        console.log(res);
        this.isLoading = false;
        this.arrService.push(...res.result.records);
        this.pageNumber++;
        this.pages = res.pages;
      });
    },
  },
  mounted: function () {
    this.pageNumber = 1;
    this.arrService = [];
    this.isLoading = false;
    this.isHadMore = true;
    this.pages = 999;
    passportUserInfo().then((res) => {
      this.list();
    });
    // this.arrService.push({
    // 	code: '2457983849435642',
    // 	type: '服务态度',
    // 	custome_name: '张飞',
    // 	custome_phone: '13523566644',
    // 	service_name: '李四',
    // 	service_phone: '13523235955',
    // 	orderCreateTime: '2022-01-02 15:23:55',
    // 	serveCreateTime: '2022-01-02 16:23:55'
    // })
    //
    // this.arrService.push({
    // 	code: '2457983834235641',
    // 	type: '服务态度',
    // 	custome_name: '刘备',
    // 	custome_phone: '19503051245',
    // 	service_name: '李四',
    // 	service_phone: '13523235955',
    // 	orderCreateTime: '2022-01-02 15:23:55',
    // 	serveCreateTime: '2022-01-02 16:23:55'
    // })
  },
};
</script>

<style scoped>
.list {
  padding: 0 0.2rem;
}
.list > .item {
  position: relative;
  background: #fff;
  border-radius: 0.2rem;
  margin: 0.2rem 0 0;
  padding: 0 0.2rem 0.2rem;
}
.list > .item > .base {
  font-size: 0.28rem;
  height: 0.88rem;
  line-height: 0.88rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list > .item > .base > .code {
  color: #333;
  font-weight: 600;
}
.list > .item > .base > .type {
  color: #999;
}
.list > .item > .info {
  position: relative;
  padding: 0.2rem 0;
}
.list > .item > .info::before,
.list > .item > .info::after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  height: 1px;
  background: #e1e1e1;
}
.list > .item > .info::before {
  top: 0;
}
.list > .item > .info::after {
  bottom: 0;
}
.list > .item > .info > .row {
  height: 0.56rem;
  line-height: 0.56rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list > .item > .info > .row > .lab {
  color: #999;
}
.list > .item > .info > .row > .inf {
  color: #555;
}
.list > .item > .link {
  padding: 0.2rem 0 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.list > .item > .link > .lnk-item {
  height: 0.6rem;
  line-height: 0.6rem;
  padding: 0 0.24rem;
  margin: 0 0 0 0.16rem;
  border-radius: 0.12rem;
}
.list > .item > .link > .lnk-ok {
  background: #1890ff;
  border: 1px solid #1890ff;
  color: #fff;
}
.list > .item > .link > .lnk-default {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #666;
}
</style>